<script>
import Multiselect from "vue-multiselect";
import required from "vuelidate/lib/validators";
//import car from "./insert_veiculo.vue";
//import rota from "./insert_rota.vue"

import { http } from "../../../../helpers/easyindustriaapi/config";
export default {
  components: {
    Multiselect,
    //  car,
    //   rota
  },
  created() {
    this.currentUser = JSON.parse(localStorage.getItem("user")); // para saber qual o usuario atual;
    this.currentEmpresa = JSON.parse(localStorage.getItem("currentEmpresa"));
  },
  props: {
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      rota: {
        nome: null,
      },
      loader: { get: false },
      titleBody: "Incluir Serviço",
      tabelas: {
        ttp_nome: null,
      },
      motorista: [
        {
          id: 1,
          nome: "motorista1",
        },
      ],
      veiculos: [
        {
          id: 1,
          nome: "veiculos1",
        },
      ],
      rotas: [
        {
          id: 1,
          nome: "rota1",
        },
      ],
      insert_embarque: {
        motorista_id: null,
        veiculo_id: null,
        rota_id: null,
        identificacao: null,
        notas: null,
        data_carregamento: null,
        data_previsao: null,
        obs: null,
      },
      select_motorista: null,
      select_rota: null,
      select_veiculos: null,
      // open_modal_car: false,
      // open_modal_rota: false,
      tipos: [
        {
          id: 1,
          nome: "Kilometragem",
        },
        {
          id: 2,
          nome: "tempo",
        },
        {
          id: 3,
          nome: "Km ou tempo",
        },
      ],
      show_input_km: false,
      show_input_tempo: false,
      show_input_km_tempo: false,
      dias: [
        {
          id: 1,
          nome: "dia",
        },
        {
          id: 2,
          nome: "mês",
        },
        {
          id: 3,
          nome: "ano",
        },
      ],
      servico: {
        nome: null,
        tp_regra: null,
        dp_roda: null,
        passarEm: null,
        tp_dia_mes_ano: null,
      },
      select_tipo: null,
      select_d_m_a: null,
    };
  },
  validations() {
    return {
      tabelas: {
        ttp_nome: { required },
      },
    };
  },
  mounted() {
    this.setNewTitle();
  },
  methods: {
    verifica_tipos(e) {
      console.log(e);
      this.servico.tp_regra = e.id;
      if (e.id == 1) {
        this.show_input_km = true;
        this.show_input_tempo = false;
        this.show_input_km_tempo = false;
      } else if (e.id == 2) {
        this.show_input_km = false;
        this.show_input_tempo = true;
        this.show_input_km_tempo = false;
      } else if (e.id == 3) {
        this.show_input_km_tempo = true;
        this.show_input_tempo = false;
        this.show_input_km = false;
      }
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    // back() {
    //   this.$emit("back");
    // },
    async doPost(rota) {
      rota = this.rota;
      rota.empresa_id = this.currentEmpresa.id;
      // embarque.user_id = this.currentUser.id;
      //this.onLoader();
      try {
        let response = await http.post(
          "/rota?empresa_id=" + this.currentEmpresa.id,
          rota
        );
        if (response) {
          //this.offLoader();
          if (response.status === 200) {
            //this.getData();
            //this.inserindo = false;
            this.makeToast("success", "Registro incluído");
          }
        }
      } catch (error) {
        //this.offLoader();
        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast("danger", "Destino URL não encontrado!");
          } else {
            this.makeToast("danger", error);
          }
        }
      }
    },
    modal_car() {
      this.open_modal_car = true;
    },
    modal_rota() {
      this.open_modal_rota = true;
    },
    back() {
      this.open_modal_rota = false;
      this.open_modal_car = false;
    },
    setNewTitle() {
      this.$emit("newTitle", this.titleBody);
    },
    setPost() {
      this.coverter_float();
      this.$emit("doPost", this.servico);
      this.voltar();
    },
    voltar() {
      this.$emit("back");
    },
    seleciona_moto(event) {
      //console.log(event)
      this.insert_embarque.motorista_id = event.id;
    },
    seleciona_rota(event) {
      this.insert_embarque.rota_id = event.id;
      //console.log(event)
    },
    seleciona_veiculo(event) {
      this.insert_embarque.veiculo_id = event.id;
      ///console.log(event)
    },
    customLabel_car({ id, nome }) {
      return `${id} – ${nome}`;
    },
    customLabel_rota({ id, nome }) {
      return `${id} – ${nome}`;
    },
    selecionar_dia_mes_ano(e) {
      this.servico.tp_dia_mes_ano = e.id;
    },
    formatInput_valor() {
      // Remova todos os caracteres não numéricos do valor de entrada
      let numericValue = this.servico.dp_roda.replace(/\D/g, "");
      // Formate o valor_pag numérico para a moeda desejada (por exemplo, BRL)
      this.servico.dp_roda = parseFloat(numericValue / 100)
        .toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })
        .replace("R$", " ");
    },
    coverter_float() {
      //typeof(this.pre_ped.valor)
      if (typeof this.servico.dp_roda == "string") {
        this.servico2 = this.servico;
        let stringValor = this.servico2.dp_roda;
        let valorFlutuante = parseFloat(
          stringValor.replace("R$", " ").replace(/\./g, "").replace(",", ".")
        );
        this.servico.dp_roda = valorFlutuante;
      }
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-12 text-left">
          <Label>Nome:</Label>
          <input
            v-model="servico.nome"
            type="text"
            class="form-control text-left"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card-header header-tag="header" class="p-1 mt-4 mb-4" role="tab">
            <b-button block v-b-toggle.pedido variant="light"
              >Regras de Manutenção</b-button
            >
          </b-card-header>
          <b-collapse id="pedido" accordion="pedido-accordion" role="tabpanel">
            <div class="card mt-4">
              <div class="card-body cor">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-md-4 text-center">
                    <Labael>Tipo: </Labael>
                    <multiselect
                      v-model="select_tipo"
                      :options="tipos"
                      @select="verifica_tipos($event)"
                      label="nome"
                    >
                    </multiselect>
                  </div>
                  <div v-if="show_input_km" class="col-md-4">
                    <Labael>Depois que Rodar:</Labael>
                    <input
                      v-model="servico.dp_roda"
                      @input="formatInput_valor()"
                      type="text"
                      class="form-control text-left"
                    />
                  </div>
                  <div v-if="show_input_tempo" class="col-md-4">
                    <Labael>quando psssar(em): </Labael>
                    <input
                      v-model="servico.passarEm"
                      type="number"
                      class="form-control"
                    />
                  </div>
                  <div v-if="show_input_tempo" class="col-md-4">
                    <Labael>&nbsp; </Labael>
                    <multiselect
                      v-model="select_d_m_a"
                      :options="dias"
                      @select="selecionar_dia_mes_ano($event)"
                      label="nome"
                    >
                    </multiselect>
                  </div>
                  <div v-if="show_input_km_tempo" class="col-md-2">
                    <Labael>Depois que rodar</Labael>
                    <input
                      v-model="servico.dp_roda"
                      @input="formatInput_valor()"
                      type="text"
                      class="form-control text-left"
                    />
                  </div>
                  <div v-if="show_input_km_tempo" class="col-md-1">
                    <Label class="mt-4"> Ou km </Label>
                  </div>
                  <div v-if="show_input_km_tempo" class="col-md-2">
                    <Labael>Quando Passar(em) </Labael>
                    <input
                      v-model="servico.passarEm"
                      type="number"
                      class="form-control text-left"
                    />
                  </div>
                  <div v-if="show_input_km_tempo" class="col-md-2">
                    <Labael>&nbsp; </Labael>
                    <multiselect
                      v-model="select_d_m_a"
                      @select="selecionar_dia_mes_ano($event)"
                      :options="dias"
                      label="nome"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-12 text-center">
          <button class="btn btn-secondary" @click="setPost()">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>